/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/destructuring-assignment */
import React, { useState } from 'react';

const ContextPtfa = React.createContext([{}, () => {}]);

function ContextPtfaProvider(props) {
  // DA MODIFICARE CON LE PROP DELL'OGGETTONE DI RIFERIMENTO
  const [state, setState] = useState({});

  return (
    <ContextPtfa.Provider value={[state, setState]}>
      {props.children}
    </ContextPtfa.Provider>
  );
}

export { ContextPtfa, ContextPtfaProvider };
